import { render, staticRenderFns } from "./transcc.vue?vue&type=template&id=21f06323&scoped=true"
import script from "./transcc.vue?vue&type=script&lang=js"
export * from "./transcc.vue?vue&type=script&lang=js"
import style0 from "./transcc.vue?vue&type=style&index=0&id=21f06323&prod&scoped=true&lang=scss"
import style1 from "./transcc.vue?vue&type=style&index=1&id=21f06323&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f06323",
  null
  
)

export default component.exports